import * as React from 'react';

import { cn, Select } from '@rematter/ui-web';
import startCase from 'lodash/startCase';

import { EntitySelectProps } from '~/shared/components/select-fields/types';

export const SelectEnum = <T extends string>({
  onChange,
  showAllOption,
  allOptionLabel,
  value,
  enumValue,
  formatOptionLabel,
  ...props
}: EntitySelectProps<T, T> & {
  enumValue: Record<string, string>;
  showAllOption?: boolean;
  allOptionLabel?: string;
  formatOptionLabel?: (value: T) => string;
}) => {
  const options = React.useMemo(
    () => [
      ...(showAllOption
        ? [{ key: 'all' as T, label: allOptionLabel ?? 'All' }]
        : []),
      ...Object.values(enumValue).map((v) => ({
        key: v as T,
        label: formatOptionLabel?.(v as T) ?? startCase(v),
      })),
    ],
    [showAllOption, allOptionLabel, enumValue, formatOptionLabel],
  );

  const handleChange = React.useCallback(
    (value: string | undefined) => {
      const effectiveValue = value === 'all' ? undefined : value;
      onChange?.(effectiveValue as T, effectiveValue as T);
    },
    [onChange],
  );

  return (
    <Select
      {...props}
      value={value ?? (showAllOption ? 'all' : undefined)}
      onChange={handleChange}
      className={cn(`@SelectEnum`, props.className)}
      options={options}
    />
  );
};
